import moment from 'moment'

export default {
    filters: {
        mixFormatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        mixHumanDate(date) {
            return moment(date).locale('es').fromNow()
        },
    },
}
